import {
    yearSingularAbbreviation,
    yearFirstPluralAbbreviation,
    yearSecondGenitivePluralAbbreviation,
    monthSingularAbbreviation,
    monthFirstPluralAbbreviation,
    monthSecondGenitivePluralAbbreviation,
    weekSingularAbbreviation,
    weekFirstPluralAbbreviation,
    weekSecondGenitivePluralAbbreviation,
    daySingularAbbreviation,
    dayFirstPluralAbbreviation,
    daySecondGenitivePluralAbbreviation,
    hourSingularAbbreviation,
    hourFirstPluralAbbreviation,
    hourSecondGenitivePluralAbbreviation,
    hourSimplifiedPluralAbbreviation,
    minuteSingularAbbreviation,
    minuteFirstPluralAbbreviation,
    minuteSecondGenitivePluralAbbreviation,
    minuteSimplifiedPluralAbbreviation,
    secondSingularAbbreviation,
    secondFirstPluralAbbreviation,
    secondSecondGenitivePluralAbbreviation,
    secondSimplifiedPluralAbbreviation,
} from './getAbbreviatedSingularPluralStrings.locstring.json';
import loc from 'owa-localize';

import createSingularPluralStrings, {
    type SingularPluralString,
} from 'owa-measurementunit-formatter/lib/createSingularPluralStrings';

// Groups the strings for each unit
export default function getAbbreviatedSingularPluralStrings(): {
    year: SingularPluralString;
    month: SingularPluralString;
    week: SingularPluralString;
    day: SingularPluralString;
    hour: SingularPluralString;
    minute: SingularPluralString;
    second: SingularPluralString;
} {
    return {
        year: createSingularPluralStrings(
            loc(yearSingularAbbreviation),
            loc(yearFirstPluralAbbreviation),
            loc(yearSecondGenitivePluralAbbreviation)
        ),
        month: createSingularPluralStrings(
            loc(monthSingularAbbreviation),
            loc(monthFirstPluralAbbreviation),
            loc(monthSecondGenitivePluralAbbreviation)
        ),
        week: createSingularPluralStrings(
            loc(weekSingularAbbreviation),
            loc(weekFirstPluralAbbreviation),
            loc(weekSecondGenitivePluralAbbreviation)
        ),
        day: createSingularPluralStrings(
            loc(daySingularAbbreviation),
            loc(dayFirstPluralAbbreviation),
            loc(daySecondGenitivePluralAbbreviation)
        ),
        hour: createSingularPluralStrings(
            loc(hourSingularAbbreviation),
            loc(hourFirstPluralAbbreviation),
            loc(hourSecondGenitivePluralAbbreviation),
            loc(hourSimplifiedPluralAbbreviation)
        ),
        minute: createSingularPluralStrings(
            loc(minuteSingularAbbreviation),
            loc(minuteFirstPluralAbbreviation),
            loc(minuteSecondGenitivePluralAbbreviation),
            loc(minuteSimplifiedPluralAbbreviation)
        ),
        second: createSingularPluralStrings(
            loc(secondSingularAbbreviation),
            loc(secondFirstPluralAbbreviation),
            loc(secondSecondGenitivePluralAbbreviation),
            loc(secondSimplifiedPluralAbbreviation)
        ),
    };
}
